import React from 'react';
import {Link} from 'react-router-dom';
import {useCategories } from '../../components/hooks/hooks-e-commerce/useCategories';
import './onlinestore.scss';

function OnlineStore() {
    const {categories} = useCategories();
    return (
        <section>
            <div className="grid-prodotti">
            {categories.map(item => (
                <div className="expo-grid__item" key={item.id}>
                    <img src={require(`../components/images/catalogo/categories/${item.immagine_categoria}`)} alt={`${item.nome} theme`} />
                    <div className="expo-item__info">
                        <p className='expo-info__title'>{item.nome}</p>
                        <p>{item.descrizione}</p>
                    </div>
                    <Link className="btn__link" to={item.collegamento}>
                        <button><span>Avanti </span></button>
                    </Link>
                </div>))}
            </div> 
        </section>
    )
}
export default OnlineStore;
